var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCheckPink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#ico_check_pink_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23,
    r: 15,
    fill: "#E92070"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.816 17.959l-1.774-1.775a.626.626 0 00-.887 0l-9.072 9.578-5.2-5.203a.636.636 0 00-.9 0l-1.797 1.8a.636.636 0 000 .898l7.396 7.568a.616.616 0 00.524.169.623.623 0 00.543-.17l11.167-11.978a.628.628 0 000-.887z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ico_check_pink_svg__filter0_d",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC45NSIgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZCkiPgo8Y2lyY2xlIGN4PSIyNCIgY3k9IjIzIiByPSIxNSIgZmlsbD0iI0U5MjA3MCIvPgo8L2c+CjxwYXRoIGQ9Ik0zMy44MTYyIDE3Ljk1ODdMMzIuMDQxOCAxNi4xODQyQzMxLjc5NjIgMTUuOTM4NiAzMS40MDA1IDE1LjkzODYgMzEuMTU0OSAxNi4xODQyTDIyLjA4MjcgMjUuNzYyMUwxNi44ODI1IDIwLjU1OTRDMTYuNjM0MyAyMC4zMTEzIDE2LjIzMTggMjAuMzExMyAxNS45ODM3IDIwLjU1OTRMMTQuMTg2MSAyMi4zNTgyQzEzLjkzOCAyMi42MDU3IDEzLjkzOCAyMy4wMDgyIDE0LjE4NjEgMjMuMjU3TDIxLjU4MiAzMC44MjQ4QzIxLjcyNTEgMzAuOTY4NiAyMS45MTk1IDMxLjAxNzkgMjIuMTA2NCAzMC45OTM2QzIyLjI5OTUgMzEuMDIyMyAyMi41MDA4IDMwLjk3MzYgMjIuNjQ4OSAzMC44MjQ4TDMzLjgxNjIgMTguODQ2MkMzNC4wNjEzIDE4LjYwMTIgMzQuMDYxMyAxOC4yMDM3IDMzLjgxNjIgMTcuOTU4N1oiIGZpbGw9IndoaXRlIi8+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2QiIHg9IjAiIHk9IjAiIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIvPgo8ZmVPZmZzZXQgZHg9IjEiIGR5PSIyIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjUiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9kcm9wU2hhZG93IiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgIcoCheckPink as ReactComponent };